import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { Formik, useFormik } from "formik";
import React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import * as yup from "yup";
// import { ActionHeader, FaqLink } from '..';
import { BackArrow } from "../UpdateNominee/SelectedFolios";
import en from "../../../lang/en-us";
import { SubmitButton } from "../../../lib/Button";
import TextInput from "../../../lib/TextField";
import { sendEmailOTP } from "../../../store/actions/nct";
import { RootStateType } from "../../../store/reducers";
import {
  OTP_ACTIONS,
  REGISTER_WITH_EMAIL,
  UPDATE_EMAIL,
} from "../../../utils/constants";
import { isError, showHelperText } from "../../../utils/utilityFunctions";
import Image from "../../Image";
import { nextScreen } from "../ChangeMobile/flow";
import EmailRelationship from "./EmailRelationship";
const { dashboard, common } = en;
export const re =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const initialValues = {
  email: "",
  emailRelationship: "",
};

const validationSchema = yup.object({
  email: yup
    .string()
    .required(common.errors.email.required)
    .email(common.errors.email.regex),
  emailRelationship: yup
    .string()
    .required(common.errors.relationship.emailRequired),
});

function ChangeEmail(props: any) {
  const {
    pan,
    pekrn,
    mobile,
    userRegisteredWith,
    email: registeredEmail,
  } = props;

  const emailFormik = useFormik({
    initialValues,
    onSubmit: async ({ email, emailRelationship }) => {
      if (registeredEmail === email) {
        alert(dashboard.changeEmail.emailError);
        return;
      }
      // const action =
      //   props?.location?.state?.action || OTP_ACTIONS.NEW_EMAIL_ONINE_OTP;

      if (props?.location?.state?.isPhygitial) {
        props.history.push(
          "/new-transaction/nct-type/phygital/change-email-document",
          {
            enteredEmail: email,
            emailRelationship: emailRelationship,
            ...(props?.location?.state || {}),
          }
        );
        return;
      }
      props.history.push(
        "/new-transaction/nct-type/digital/change-email-list",
        {
          enteredEmail: email,
          emailRelationship: emailRelationship,
          ...(props?.location?.state || {}),
        }
      );
      const goTo = nextScreen(props.match.path, "email");
    },
    validationSchema,
  });
  return (
    <div className="curved-bg nct-layout" style={{ padding: 0 }}>
      <BackArrow history={props.history} />
      <div className="curved-bg-content">
        <Image
          className="change-email-img"
          src="/images/change-email-img.png"
          alt="icon"
        />
        <div className="curved-bg-content-inner xs-alignment">
          <div className="curved-bg-content-inner-top change-email-top">
            <h3
              className="subheading"
              style={{
                marginBottom: "40px",
                marginTop: "10px",
                fontFamily: "OpenSans-SemiBold",
                //fontSize: "15px",
                // lineHeight: "18px",
                // color: " #4f4f4f",
                // width:"75%"
                textAlign: "left",
              }}
            >
              {dashboard.changeEmail.subHeading}
            </h3>
            <p style={{ marginLeft: 20 }}>
              {dashboard.changeEmail.subHeadingInfo}
            </p>
            <div
              className="email_container"
              style={{ display: "flex", margin: "20px" }}
            >
              <div>
                <label
                  style={{
                    fontFamily: "OpenSans-SemiBold",
                    fontSize: "15px",
                    lineHeight: "18px",
                    color: " #4f4f4f",
                  }}
                >
                  Enter New Email
                </label>
                <TextInput
                  hiddenLabel
                  variant="outlined"
                  onChange={emailFormik.handleChange}
                  placeholder="Enter Here"
                  error={isError(emailFormik, "email")}
                  helperText={showHelperText(emailFormik, "email")}
                  value={emailFormik.values.email}
                  name="email"
                  style={{ width: "90%" }}
                  className="email_text_input"
                />
              </div>
              <EmailRelationship emailFormik={emailFormik} />
            </div>
          </div>
          {/* <FaqLink section={UPDATE_EMAIL} history={props.history} /> */}
        </div>
        <div
          className="curved-bg-content-inner-bottom nct-button"
          style={{ alignItems: "flex-start" }}
        >
          <SubmitButton
            label={dashboard.changeEmail.buttonText}
            onClick={emailFormik.handleSubmit as any}
            className="customBtn"
          />
        </div>
      </div>
    </div>
  );
}

export default connect(
  ({ authReducer, investor }: RootStateType) => ({
    ...authReducer,
    ...investor,
  }),
  { sendEmailOTP }
)(ChangeEmail);
